import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import CreditGuardBlockData from '../../../Models/Content/CreditGuardBlockData';
import Main from './main';
export default class CreditGuardBlock extends EpiComponent<CreditGuardBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
  
    return (
      <div >
        <Main />
      </div>
    );
  }
}
